/* Stone finder quiz logic. Needs stone-finder-data.js first. */
(function () {
  var root = document.querySelector('.sfq');
  if (!root || !window.SFQ_DATA) return;
  var D = window.SFQ_DATA;
  var STONES = D.STONES, SIGNS = D.SIGNS, IMG = D.IMG, LIFE = D.LIFE, PLACES = D.PLACES, FRIENDS = D.FRIENDS, COLOURS = D.COLOURS, NEAR = D.NEAR, SINTA = D.SINTA, RING = D.RING, LILA = D.LILA, SAYA = D.SAYA, MAYARI = D.MAYARI;

  var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  var DAYS_IN = [31,29,31,30,31,30,31,31,30,31,30,31];
  var STARTS = [20,19,21,20,21,21,23,23,23,23,22,22];
  var START_SIGN = [10,11,0,1,2,3,4,5,6,7,8,9];
  var ORDER = ['life', 'colour', 'friend', 'place'];
  var WEIGHT = { life: 3, colour: 2, friend: 1, place: 1 };
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  var st = { step: 1, who: 'Someone else', day: 0, month: 0, life: null, place: null, friend: null, colour: null };

  function $(sel) { return root.querySelector(sel); }
  function $$(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function cap(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }

  function signFor() {
    var i = st.month - 1;
    return SIGNS[st.day >= STARTS[i] ? START_SIGN[i] : START_SIGN[(i + 11) % 12]];
  }

  function answers() {
    var a = {};
    if (st.life !== null) a.life = { stone: LIFE[st.life][2], reason: LIFE[st.life][3] };
    if (st.place !== null) a.place = { stone: PLACES[st.place][2], reason: PLACES[st.place][3] };
    if (st.friend !== null) a.friend = { stone: FRIENDS[st.friend][1], reason: FRIENDS[st.friend][2] };
    if (st.colour !== null) a.colour = { stone: COLOURS[st.colour][2], reason: COLOURS[st.colour][3] };
    return a;
  }

  // Three different stones: the sign stone, then the two strongest from the answers.
  // A stone is never repeated; if the answers run out, the closest stone in colour fills the slot.
  function pickStones(sg) {
    var a = answers(), score = {}, first = {};
    ORDER.forEach(function (k, i) {
      if (!a[k]) return;
      var s = a[k].stone;
      score[s] = (score[s] || 0) + WEIGHT[k];
      if (first[s] === undefined) first[s] = i;
    });
    var ranked = Object.keys(score)
      .filter(function (k) { return STONES[k].name !== sg.stone; })
      .sort(function (x, y) { return (score[y] - score[x]) || (first[x] - first[y]); })
      .map(function (s) { return { key: s, reasons: ORDER.filter(function (k) { return a[k] && a[k].stone === s; }).map(function (k) { return a[k].reason; }) }; });
    var signKey = Object.keys(STONES).filter(function (k) { return STONES[k].name === sg.stone; })[0];
    var pool = [].concat(signKey ? NEAR[signKey] : [], ranked[0] ? NEAR[ranked[0].key] : [], Object.keys(STONES));
    pool.forEach(function (k) {
      if (ranked.length < 2 && STONES[k].name !== sg.stone && !ranked.some(function (x) { return x.key === k; })) ranked.push({ key: k, reasons: [] });
    });
    return ranked.slice(0, 2);
  }

  function copy() {
    var me = st.who === 'Me';
    return {
      birthday: me ? 'When is your birthday?' : 'When is their birthday?',
      life: me ? 'Life at the moment' : 'Their life at the moment',
      place: me ? 'Where you feel most yourself' : 'Where they feel most themselves',
      friend: me ? 'How your friends would describe you' : 'How you would describe them',
      colour: me ? 'The colours you reach for' : 'The colours they wear',
      email: me ? "You'll see your stones here, and we'll send a note two weeks before your birthday each year." : "You'll see their stones here, and we'll send a note two weeks before their birthday each year."
    };
  }

  function show(n) {
    st.step = n;
    var c = copy();
    $$('[data-q]').forEach(function (q) { q.textContent = c[q.getAttribute('data-q')] || q.textContent; });
    $$('.sfq__step').forEach(function (s) { s.hidden = +s.getAttribute('data-step') !== n; });
    $$('[data-step-only]').forEach(function (s) { s.hidden = +s.getAttribute('data-step-only') !== n; });
    $('.sfq__progress').textContent = n <= 6 ? pad(n) + ' / 06' : '';
    if (n > 1) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // Build options.
  function tile(label, inner, onPick) {
    var b = el('button', 'sfq__tile'); b.type = 'button';
    var box = el('span', 'sfq__img'); box.appendChild(inner); b.appendChild(box);
    b.appendChild(el('span', 'sfq__tl', label));
    b.addEventListener('click', onPick);
    return b;
  }
  function photo(file, alt) { var i = document.createElement('img'); i.loading = 'lazy'; i.alt = alt; i.src = IMG + file + '?width=600'; return i; }
  LIFE.forEach(function (t, i) { $('[data-tiles="life"]').appendChild(tile(t[0], photo(t[1], ''), function () { st.life = i; show(4); })); });
  PLACES.forEach(function (t, i) { $('[data-tiles="place"]').appendChild(tile(t[0], photo(t[1], ''), function () { st.place = i; show(5); })); });
  FRIENDS.forEach(function (f, i) {
    var b = el('button', 'sfq__li', f[0]); b.type = 'button';
    b.addEventListener('click', function () { st.friend = i; show(6); });
    $('[data-list-of="friend"]').appendChild(b);
  });
  COLOURS.forEach(function (c, i) {
    var s = el('span', 'sfq__sphere'); s.style.background = c[1]; s.setAttribute('aria-hidden', 'true');
    $('[data-tiles="colour"]').appendChild(tile(c[0], s, function () { st.colour = i; show(7); }));
  });
  $$('[data-who]').forEach(function (b) { b.addEventListener('click', function () { st.who = b.getAttribute('data-who'); show(2); }); });
  $$('[data-back]').forEach(function (b) { b.addEventListener('click', function () { show(Math.max(1, st.step - 1)); }); });

  // Birthday selects.
  var daySel = $('select[name="day"]'), monthSel = $('select[name="month"]');
  function opt(sel, v, t) { var o = document.createElement('option'); o.value = v; o.textContent = t; sel.appendChild(o); }
  opt(monthSel, '', 'Month'); MONTHS.forEach(function (m, i) { opt(monthSel, i + 1, m); });
  function fillDays() {
    var keep = daySel.value, max = monthSel.value ? DAYS_IN[monthSel.value - 1] : 31;
    daySel.innerHTML = ''; opt(daySel, '', 'Day');
    for (var d = 1; d <= max; d++) opt(daySel, d, d);
    if (keep && +keep <= max) daySel.value = keep;
  }
  fillDays(); monthSel.addEventListener('change', fillDays);
  $('[data-next]').addEventListener('click', function () {
    st.month = +monthSel.value; st.day = +daySel.value;
    if (!st.month || !st.day) { (st.month ? daySel : monthSel).focus(); return; }
    show(3);
  });

  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'DKK';
    var n = cents / 100;
    if (cur === 'DKK') return (n % 1 ? n.toFixed(2).replace('.', ',') : n.toLocaleString('da-DK')) + ' kr';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: cur }).format(n); } catch (e) { return n + ' ' + cur; }
  }
  function getProduct(handle) {
    return fetch(base + 'products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }

  function buildResult() {
    var sg = signFor(), two = pickStones(sg), me = st.who === 'Me', a = answers();
    var k1 = two[0].key, k2 = two[1].key;
    var stones = [
      { role: 'sign', name: sg.stone, color: sg.color, kw: sg.kw, mean: sg.mean, why: 'The stone for ' + sg.sign + '.' },
      { role: 'now', name: STONES[k1].name, color: STONES[k1].color, kw: STONES[k1].kw, mean: STONES[k1].mean, why: two[0].reasons.length ? cap(two[0].reasons.join(', ')) + '.' : 'Close in colour to the rest of your stones.' },
      { role: 'you', name: STONES[k2].name, color: STONES[k2].color, kw: STONES[k2].kw, mean: STONES[k2].mean, why: two[1].reasons.length ? cap(two[1].reasons.join(', ')) + '.' : 'Close in colour to the rest of your stones.' }
    ];
    var pieces = [
      { title: 'Tanda necklace', stone: sg.stone, color: sg.color, handle: sg.handle, tanda: true },
      { title: 'Sinta bracelet', stone: STONES[k1].name, color: STONES[k1].color, handle: SINTA[k1] },
      { title: 'Beaded ring', stone: STONES[k2].name, color: STONES[k2].color, handle: RING[k2] },
      { title: 'Lila necklace', stone: STONES[k1].name, color: STONES[k1].color, handle: LILA[k1] }
    ];
    var sayaKey = SAYA[k2] ? k2 : k1, mayariKey = MAYARI[k1] ? k1 : k2;
    if (SAYA[sayaKey]) pieces.push({ title: 'Saya earrings', stone: STONES[sayaKey].name, color: STONES[sayaKey].color, handle: SAYA[sayaKey] });
    if (MAYARI[mayariKey]) pieces.push({ title: 'Mayari necklace', stone: STONES[mayariKey].name, color: STONES[mayariKey].color, handle: MAYARI[mayariKey] });
    var portrait = cap([a.life && a.life.reason, a.place && a.place.reason, a.friend && a.friend.reason].filter(Boolean).join(', ')) + '.';
    return { sg: sg, me: me, stones: stones, pieces: pieces, portrait: portrait };
  }

  function renderResult(r) {
    $('[data-r="eyebrow"]').textContent = r.sg.sign + ' · ' + r.sg.dates;
    $('[data-r="title"]').textContent = r.me ? 'Your stones' : 'Their stones';
    $('[data-r="portrait"]').textContent = r.portrait;
    $('[data-r="pieces-title"]').textContent = r.me ? 'Pieces in your stones' : 'Pieces in their stones';
    $('[data-r="reminder"]').textContent = r.me
      ? 'A copy is in your inbox. We will write again two weeks before your birthday.'
      : 'A copy is in your inbox. We will write again two weeks before their birthday, so there is time to order.';
    var sBox = $('[data-r="stones"]'); sBox.innerHTML = '';
    r.stones.forEach(function (s) {
      var d = el('div', 'sfq__stone'), p = el('div', 'sfq__splate'), sp = el('span', 'sfq__sphere');
      sp.style.background = s.color; p.appendChild(sp); d.appendChild(p); d.appendChild(el('span', 'sfq__sname', s.name)); sBox.appendChild(d);
    });
    var grid = $('[data-r="pieces"]'); grid.innerHTML = '';
    r.pieces.forEach(function (pc) {
      var a = el('a', 'sfq__card'); a.href = base + 'products/' + pc.handle;
      var plate = el('div', 'sfq__plate');
      if (pc.image) { var i = document.createElement('img'); i.loading = 'lazy'; i.alt = pc.title + ', ' + pc.stone; i.src = pc.image + (pc.image.indexOf('?') > -1 ? '&' : '?') + 'width=600'; plate.appendChild(i); }
      else { var sp = el('span', 'sfq__sphere'); sp.style.background = pc.color; plate.appendChild(sp); }
      a.appendChild(plate); a.appendChild(el('span', null, pc.title)); a.appendChild(el('small', null, pc.stone + ' · ' + (pc.price || '')));
      if (!pc.available && pc.tanda) a.removeAttribute('href');
      grid.appendChild(a);
    });
    $('.sfq__quiz').hidden = true;
    $('.sfq__result').hidden = false;
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function loadPieces(r) {
    return Promise.all(r.pieces.map(function (pc) {
      return getProduct(pc.handle).then(function (p) {
        if (p) {
          pc.available = !!p.available;
          pc.price = money(p.price);
          pc.url = location.origin + base + 'products/' + pc.handle;
          var img = p.featured_image || '';
          pc.image = img ? (img.indexOf('//') === 0 ? 'https:' + img : img) : '';
        } else if (pc.tanda) {
          pc.available = false;
          pc.price = (root.dataset.tandaFallback || '') + ' · Arrives 1 November';
          pc.url = location.origin + base + 'pages/stone';
        }
        return pc;
      });
    }));
  }

  function klaviyo(path, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(root.dataset.company), {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' }, body: JSON.stringify(body)
    }).then(function (res) { if (!res.ok) throw new Error(res.status); });
  }

  var form = $('.sfq__email');
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = form.querySelector('input[name="email"]').value.trim();
    var err = form.querySelector('.sfq__error');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { err.hidden = false; return; }
    err.hidden = true;
    var btn = form.querySelector('button[type="submit"]'); btn.disabled = true;

    var r = buildResult();
    loadPieces(r).then(function () {
      renderResult(r);
      var params = new URLSearchParams(location.search);
      var props = {
        'Stone birthday': '2000-' + pad(st.month) + '-' + pad(st.day),
        'Stone sign': r.sg.sign,
        'Stone for': st.who,
        'Stone 1': r.stones[0].name,
        'Stone 2': r.stones[1].name,
        'Stone 3': r.stones[2].name,
        'Stone tanda url': location.origin + base + 'products/' + r.sg.handle,
        'Stone finder source': params.get('utm_source') || '',
        'Stone finder campaign': params.get('utm_campaign') || ''
      };
      var sub = { data: { type: 'subscription', attributes: { custom_source: 'Stone finder', profile: { data: { type: 'profile', attributes: { email: email, properties: props } } } }, relationships: { list: { data: { type: 'list', id: root.dataset.list } } } } };
      var ev = { data: { type: 'event', attributes: {
        metric: { data: { type: 'metric', attributes: { name: 'Completed Stone Finder' } } },
        profile: { data: { type: 'profile', attributes: { email: email } } },
        properties: {
          who: st.who, sign: r.sg.sign, sign_dates: r.sg.dates, portrait: r.portrait,
          stones: r.stones.map(function (s) { return { name: s.name, keywords: s.kw, meaning: s.mean, why: s.why, color: s.color }; }),
          pieces: r.pieces.map(function (pc) { return { title: pc.title, stone: pc.stone, price: pc.price || '', url: pc.url || (location.origin + base + 'products/' + pc.handle), image: pc.image || '' }; }),
          page_url: location.origin + base + 'pages/stone'
        }
      } } };
      return klaviyo('subscriptions', sub).then(function () { return klaviyo('events', ev); });
    }).then(function () {
      try { if (window.fbq) fbq('track', 'Lead', { content_name: 'Stone finder' }); } catch (x) {}
    }).catch(function () {
      // Results stay on screen; the email simply did not go through.
    }).then(function () { btn.disabled = false; });
  });

  $('[data-restart]').addEventListener('click', function () {
    st.life = st.place = st.friend = st.colour = null;
    $('.sfq__result').hidden = true; $('.sfq__quiz').hidden = false; show(1);
  });

  show(1);
})();